











































import { Component, Vue } from 'vue-property-decorator';

import { Event as EventEnum } from '@/enums/Event';

import { Event } from '@/util/Event';

import { Store } from '@/enums/Store';

import { namespace } from 'vuex-class';

import EventOverview from '@/components/Overview/EventOverview.vue';
import MemberList from '@/components/Overview/Member/MemberList.vue';
import LocationOverview from '@/components/Overview/LocationOverview.vue';
import BillingOverview from '@/components/Overview/BillingOverview.vue';

const EVENT = namespace(Store.EVENT);
const APP = namespace(Store.APP);

@Component({
  components: { BillingOverview, LocationOverview, MemberList, EventOverview }
})
export default class Overview extends Vue {
  @EVENT.Getter('selectedEventObject') event!: Event;

  @APP.State('step') step!: number;

  collapsed = window.innerWidth < 768;

  created() {
    window.onresize = () => {
      this.collapsed = window.innerWidth < 768;
    };
  }

  get isLivestream() {
    const isLivestream = this.event.type === EventEnum.LIVESTREAM;
    return isLivestream;
  }

  get showLocationOverview() {
    return this.step >= 1;
  }

  get showMemberList() {
    if (this.isLivestream) {
      return this.step >= 2;
    }

    return this.step >= 1;
  }

  get showMemberButtons() {
    if (this.isLivestream) {
      return this.step == 2;
    }

    return this.step == 1;
  }

  get showBillingOverview() {
    if (this.isLivestream) {
      return this.step >= 3;
    }

    return this.step >= 2;
  }
}
